export const API_BASE_PATH = '/api/v1';

export const defaultAppData = {
  googleAnalyticsId: 'UA-103831275-1',
  user: {
    id: 0,
    rootBusinessUnit: { id: 0 },
    currentBusinessUnit: { id: 0 },
    isAdmin: false,
  },
  localizationInfo: { Locale: 'en-US' },
};

export const pages = {
  step1: { key: 'step1', index: 0 },
  step2: { key: 'step2', index: 1 },
};



// WEBPACK FOOTER //
// ./src/Shared/constants.js